import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Individual } from '../model/individual/individual';
import { UpdateFinanceIndividual } from '../model/individual/update-finance-individual';
import { UpdateEmploiIndividual } from '../model/individual/update-emploi-individual';
import { UpdatePieceIndividual } from '../model/individual/update-piece-individual';
import { UpdateInfoIndividual } from '../model/individual/update-info-individual';

@Injectable({
    providedIn: 'root'
})
export class IndividualService{

    constructor(private _restClientService : RestClientService) 
    {}
    
    getIndividualByRequestId(requestid)
    {
      return this._restClientService.load<Individual>('individual/individual-by-requestid/'+requestid);
    }

    getIndividualById(IndividualId)
    {
      return this._restClientService.load<Individual>('individual/find-by-id/'+IndividualId);
    }

    updateFinance(updateFinanceIndividual: UpdateFinanceIndividual ) 
    {
        return  this._restClientService.put<Individual>('individual/update-finance', updateFinanceIndividual);
    }
       
    updateEmploi(updateEmploiIndividual: UpdateEmploiIndividual ) 
    {
        return  this._restClientService.put<Individual>('individual/update-emploi', updateEmploiIndividual);
    }
       
    updatePiece(updatePieceIndividual: UpdatePieceIndividual) 
    {
        return  this._restClientService.put<Individual>('individual/update-piece', updatePieceIndividual);
    }
         
    updateInfo(updateInfoIndividual: UpdateInfoIndividual) 
    {
        return  this._restClientService.put<Individual>('individual/update-info', updateInfoIndividual);
    }
       
    getAllIndividuals()
    {
      return this._restClientService.load<Individual[]>('individual/individuals');
    }

    getIndividualByCodeClient(codeClient)
    {
      return this._restClientService.load<Individual>('individual/individual-by-codeclient/'+codeClient);
    }

}